import React, { useEffect } from 'react';
import { Button } from '@mui/material';
import QRCode from 'react-qr-code';
import {
  ModalActions,
  ModalHeader,
  ModalSubtitle,
  ModalTitle,
  QrContainer,
  QrFrame,
  StyledDialog,
  ACCOUNT_QR_MODAL_Z_INDEX,
} from './style';

export interface AccountQrModalLabels {
  title: string;
  subtitle: string;
  viewProfile: string;
  close: string;
}

const DEFAULT_LABELS: AccountQrModalLabels = {
  title: 'Quick Check-in',
  subtitle: 'Scan QR Code for quick Check-in',
  viewProfile: 'View My Profile',
  close: 'Close',
};

export interface AccountQrModalProps {
  open: boolean;
  onClose: () => void;
  qrCodeValue: string;
  onViewProfile: () => void;
  /** The DFC village passes its own (English or Arabic); every other header keeps the defaults. */
  labels?: AccountQrModalLabels;
}

const AccountQrModal: React.FC<AccountQrModalProps> = ({
  open,
  onClose,
  qrCodeValue,
  onViewProfile,
  labels = DEFAULT_LABELS,
}) => {
  useEffect(() => {
    if (open) {
      document.body.setAttribute('data-account-qr-modal-open', 'true');
    } else {
      document.body.removeAttribute('data-account-qr-modal-open');
    }

    return () => {
      document.body.removeAttribute('data-account-qr-modal-open');
    };
  }, [open]);

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      aria-labelledby="account-qr-modal-title"
      sx={{ zIndex: ACCOUNT_QR_MODAL_Z_INDEX }}
      BackdropProps={{
        sx: {
          touchAction: 'none',
        },
      }}
    >
    <ModalHeader>
      <ModalTitle id="account-qr-modal-title">{labels.title}</ModalTitle>
      <ModalSubtitle>{labels.subtitle}</ModalSubtitle>
    </ModalHeader>

    <QrContainer>
      <QrFrame>
        <QRCode value={qrCodeValue} size={200} level="H" />
      </QrFrame>
    </QrContainer>

    <ModalActions>
      <Button variant="contained" onClick={onViewProfile} fullWidth>
        {labels.viewProfile}
      </Button>
      <Button variant="text" onClick={onClose} fullWidth>
        {labels.close}
      </Button>
    </ModalActions>
  </StyledDialog>
  );
};

export default AccountQrModal;
